import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import NewsSearchContext from '../../../application/Context/NewsSearchContext';
import { useTranslation } from 'react-i18next';
export var Info = function () {
    var t = useTranslation(['news']).t;
    var count = React.useContext(NewsSearchContext).count;
    React.useEffect(function () {
    }, []);
    return (_jsx("div", { className: "under-filter-info", children: _jsxs("div", { children: [count, " ", t("éléments")] }) }));
};
